import React from "react";
import { ToolbarButton } from "../Toolbar/ToolbarButton";
import i18next from "i18next";
import ElevationSvg from "../../img/elevation.svg";
import { useMapContext } from "../../Contexts/MapContext";

export const ElevationButton = (): JSX.Element => {
    const { elevationVisible, setElevationVisible, elevationDisabled } = useMapContext();

    return (
        <div className="geolite-map-button elevation-container ol-unselectable ol-control">
            <ToolbarButton
                iconSvg={ElevationSvg}
                onClick={() => setElevationVisible(!elevationVisible)}
                title={i18next.t("elevation.elevationProfile")}
                disabled={elevationDisabled}
            />
        </div>
    );
};
